import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const importAcPrmp = [
    {
        key: "import-ac-prmp",
        path: `${APP_PREFIX_PATH}/import-ac-prmp`,
        component: React.lazy(() => import("views/app-views/importAcPrmp")),
    },
]
